import { useQuery } from '@mint-lib/query-client';
import { MediaPlan } from '@mint-sdk/api-media-plan';

import { useChosenLevel } from '../../hooks/useChosenLevel.js';
import { useChosenVersionId } from '../../hooks/useChosenVersionId.js';

export const useFlightSummaryApi = ({ enabled = true } = {}) => {
  const { id } = useChosenLevel();
  const flightVersionId = useChosenVersionId();

  return useQuery({
    ...MediaPlan.getFlightSummaryQueryOptions({
      urlParams: {
        mediaDataId: id ?? '',
      },
      params: {
        flightVersionId,
      },
    }),
    enabled: enabled && !!id,
  });
};
